import React, { useState, useEffect } from 'react';

const LastVisitLocation = () => {
  const [userLocation, setUserLocation] = useState(null);

  useEffect(() => {
    const storedLastVisitLocation = JSON.parse(localStorage.getItem('lastVisitLocation'));

    if (storedLastVisitLocation?.city) {
      setUserLocation(storedLastVisitLocation);
    }

    const fetchLocation = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        const newLocation = {
          city: data.city,
          country: data.country_name,
        };
        setUserLocation(newLocation);
        localStorage.setItem('lastVisitLocation', JSON.stringify(newLocation));
      } catch (error) {
        console.error('Location fetch failed:', error.message);
      }
    };

    fetchLocation();
  }, []);

  const displayLocation = userLocation || { city: 'Unknown', country: '' };

  return (
    <div className="lastVisit">
      <p>
        Last visit: {displayLocation.city}{displayLocation.country ? `, ${displayLocation.country}` : ''}
      </p>
    </div>
  );
};

export default LastVisitLocation;
